<template>
  <ion-card class="ion-padding bg-white no-shadow border-default w-100 max-w-d">
    <Form
      form-name="login"
      id="loginForm"
      ref="loginForm"
      class="w-100"
      :validation-schema="swiperSignUp?.activeIndex == 0 ? schemaSignUpEmail : schemaSignUpPassword"
      @submit="handleSignUpSubmit"
    >
      <swiper class="w-100" ref="signUpSwiper" :modules="[Navigation]" @swiper="onSwiper">
        <swiper-slide class="swiper-no-swiping">
          <SignUpStepperEmail />
        </swiper-slide>
        <swiper-slide class="swiper-no-swiping">
          <SignUpStepperPassword />
        </swiper-slide>
      </swiper>
      <ion-row v-if="swiperSignUp?.activeIndex == 0">
        <ion-col size="6">
          <ion-button
            fill="clear"
            class="text-sm"
            color="primary"
            expand="block"
            size="default"
            @click="goBack"
          >
            <ion-icon slot="start" :icon="chevronBackOutline" inner="true"></ion-icon>
            {{ t('global.back') }}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            fill="solid"
            class="text-sm"
            color="primary"
            expand="block"
            size="default"
            type="submit"
          >
            <ion-icon slot="end" :icon="chevronForwardOutline" inner="true"></ion-icon>
            {{ t('global.next') }}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12">
          <ion-button
            :disabled="isLoading"
            fill="solid"
            class="text-sm"
            color="primary"
            expand="block"
            size="default"
            type="submit"
          >
            {{ t('actions.createAccount') }}
          </ion-button>
        </ion-col>
      </ion-row>
    </Form>

    <ion-progress-bar v-if="isLoading" type="indeterminate" class="mt-xs"></ion-progress-bar>
  </ion-card>
</template>

<script setup lang="ts">
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import SignUpStepperEmail from '@/components/sign-up/SignUpStepperEmail.vue';
  import SignUpStepperPassword from '@/components/sign-up/SignUpStepperPassword.vue';
  import { Navigation } from 'swiper/modules';
  import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';
  import { IonButton, IonCol, IonIcon, IonRow, IonProgressBar, IonCard } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import router from '@/router';
  import { useSignUp } from '@/composables/useSignUp';
  import { Form } from 'vee-validate';
  import { useAuth } from '@/composables/useAuth';
  import { ref } from 'vue';
  import { useSchemas } from '@/composables/useSchemas';

  const { t } = useI18n();
  const { swiperSignUp, handleSignUp, clearLoginForm, signUpForm, signUpSuccess } = useSignUp();
  const { goTo } = useAuth();
  const { schemaSignUpEmail, schemaSignUpPassword } = useSchemas()
  const isLoading = ref(false);

  interface LoginForm {
    resetForm: () => void;
  }

  const loginForm = ref<LoginForm | null>(null);

  function onSwiper(swiper: any) {
    swiperSignUp.value = swiper;
  }

  const handleSignUpSubmit = () => {
    if (swiperSignUp.value?.activeIndex == 0) {
      swiperSignUp.value?.slideNext();
    } else {
      if (signUpForm.value.password != '') {
        isLoading.value = true;
        handleSignUp().then(() => {
          isLoading.value = false;
          if (signUpSuccess.value) {
            onSuccess();
          }
        });
      }
    }
  };

  const onSuccess = async () => {
    await swiperSignUp.value?.slideTo(0);
    await clearLoginForm();
    await loginForm.value?.resetForm();
    goTo('login');
  };

  const goBack = () => {
    router.back();
  };
</script>
<style scoped lang="scss">
  .swiper {
    width: 100% !important;
    height: 100%;
  }

  .max-w-d {
    max-width: 413px;
  }
</style>
